if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')){
          if(this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        this.product_id = '';
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            const upsell_overlay = document.querySelector('.upsell-overlay');

            if(upsell_overlay){
              upsell_overlay.classList.remove('is-active');
            }
            
            this.product_id = response.id;
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.triggerPopup(this.product_id);
          });
      }

      triggerPopup(product_id){
        console.log(product_id);
        // 🔹 Product IDs you want to target
        const targetProductIds = [
          41439039029337,
          41439039062105,
          40997389893721,
          40997389926489,
          40936537653337,
          40951178887257,
          41198387626073,
          41198387658841,
          41760414138457,
          41760414171225,
          41848124932185,
          41848124932185,
          40806079004761,
          40806079037529,
          40806079070297,
          40946431295577,
          40946369691737,
          40946369757273,
          40946369724505,
          40997378981977,
          40946422546521,
          40946422612057
        ];

        // 🔹 Get all product IDs from the page
        const productID = product_id;

        if (targetProductIds.includes(productID)) {
        // 🔹 Trigger popup if match found
          console.log('hit');
          let timeLeft = 0;
          const TOTAL_TIME = 33; // seconds
          timeLeft = timeLeft + TOTAL_TIME;

          const countdownEl = document.getElementById('countdown');
          const progressBar = document.getElementById('upsell-progress');
          const closeBtn = document.getElementById('closeUpsell');
          const overlay = document.querySelector('.upsell-overlay');
          console.log(overlay);
          setTimeout(() => {
            overlay.classList.add('is-active');
          }, 3000);

          function updateTimer() {
            const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
            const seconds = String(timeLeft % 60).padStart(2, '0');
            countdownEl.textContent = `${minutes}:${seconds}`;

            const progress = timeLeft / TOTAL_TIME;
            progressBar.style.transform = `scaleX(${progress})`;

            if (timeLeft <= 0) {
              clearInterval(timerInterval);
            overlay.classList.remove('is-active');
            }

            timeLeft--;
          }

          const timerInterval = setInterval(updateTimer, 1000);
          updateTimer();

          closeBtn.addEventListener('click', () => {
            clearInterval(timerInterval);
            overlay.classList.remove('is-active');
          });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
